import React from 'react';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import { keyframes } from '@mui/system';
import spinnerArrowsPath from 'assets/images/Arrows.svg';
import { remCalc } from '../../../util/style-util';
import { getTranslatedImage } from '../../../translations/translator';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const RotatingImage = styled('img')({
  width: remCalc(50),
  marginLeft: remCalc(-96),
  animation: `${spin} 2s infinite ease`
});

type Props = {
  loading?: boolean;
  timeout?: number;
};

const LoadingScreen = ({ loading }: Props): React.ReactElement | null => {
  const { loadingContainer, notebook } = useStyles();

  return loading ? (
    <div className={loadingContainer}>
      <img src={getTranslatedImage('notepad.svg')} className={notebook} alt="Notebook" />
      <RotatingImage src={spinnerArrowsPath} alt="Spinner" />
    </div>
  ) : null;
};

const useStyles = makeStyles(() => ({
  loadingContainer: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 8,
    display: 'flex',
    justifyContent: 'center',
    userSelect: 'none'
  },
  notebook: {
    width: remCalc(150),
    marginLeft: remCalc(-48)
  }
}));

export default LoadingScreen;
